import { InputWithLabel, SelectWithLabel } from '@adotel/components'
import { MenuItem, Typography } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import { useState } from 'react'

import TimePeriodForm from '../../components/TimePeriodForm'
import { DateObject } from '../../helpers/date'
import { getTranslate } from '../../localization'
import { SessionStatus } from '../../types/adminConfig'
import { GetSessionsInput } from '../../types/iamSessions'
import useStyles from './styles/index.styles'

type SessionFiltersProps = {
  sessionsInput: GetSessionsInput
  setSessionsInput: React.Dispatch<React.SetStateAction<GetSessionsInput>>
  dateObject: DateObject
  setDateObject: React.Dispatch<React.SetStateAction<DateObject>>
}

export default function SessionFilters({
  sessionsInput,
  setSessionsInput,
  dateObject,
  setDateObject
}: SessionFiltersProps) {
  const classes = useStyles()
  const [timePeriodOpen, setTimePeriodOpen] = useState(false)
  const [onDoneClickForCloseDatePicker, setOnDoneClickForCloseDatePicker] =
    useState<boolean>(true)
  return (
    <div className={classes.container}>
      <InputWithLabel
        placeholder={getTranslate(
          'Search by username, userId, or sessionId...'
        )}
        label={getTranslate('Search')}
        noHelperText
        className={classes.input}
        value={sessionsInput.email}
        onChange={(event) => {
          const value = (event.target as HTMLInputElement).value
          setSessionsInput((prev) => ({
            ...prev,
            pagination: { page: 1, perPage: 8 },
            email: value
          }))
        }}
        inputSize="small"
        startIcon={<SearchIcon />}
      />
      <SelectWithLabel
        fullWidth
        noHelperText
        label={getTranslate('Session Status')}
        value={sessionsInput.sessionState ?? 'ALL'}
        className={classes.input}
        onChange={(e) =>
          setSessionsInput((prev) => ({
            ...prev,
            sessionState:
              e.target.value === 'ALL'
                ? undefined
                : (e.target.value as SessionStatus), // or string if not typed
            pagination: { page: 1, perPage: 8 }
          }))
        }
        size="small">
        <MenuItem key="all" value="ALL">
          {getTranslate('All')}
        </MenuItem>

        <MenuItem key="Active" value="Active">
          {getTranslate('Active')}
        </MenuItem>

        <MenuItem key="Revoked" value="Revoked">
          {getTranslate('Revoked')}
        </MenuItem>

        <MenuItem key="Expired" value="Expired">
          {getTranslate('Expired')}
        </MenuItem>

        <MenuItem key="Compromised" value="Compromised">
          {getTranslate('Compromised')}
        </MenuItem>

        <MenuItem key="Pending2FA" value="Pending2FA">
          {getTranslate('Pending 2FA')}
        </MenuItem>

        <MenuItem key="Locked2FA" value="Locked2FA">
          {getTranslate('Locked 2FA')}
        </MenuItem>

        <MenuItem
          key="PendingUpdatePhoneNumber"
          value="PendingUpdatePhoneNumber">
          {getTranslate('Pending Phone Update')}
        </MenuItem>
      </SelectWithLabel>
      <div>
        <Typography>{getTranslate('Initiate Range')}</Typography>
        <TimePeriodForm
          isOpen={timePeriodOpen}
          setTimePickerSelected={setTimePeriodOpen}
          dateObject={dateObject}
          onChange={(data: DateObject) => {
            setDateObject(data)

            setSessionsInput((prev) => ({
              ...prev,
              initiationRange: {
                from: data.gregorianStartDate,
                to: data.gregorianEndDate
              },
              pagination: { page: 1, perPage: 8 }
            }))
          }}
          onDoneClickForCloseDatePicker={onDoneClickForCloseDatePicker}
          setOnDoneClickForCloseDatePicker={setOnDoneClickForCloseDatePicker}
          enableAllDays
        />
      </div>
    </div>
  )
}
